/**
 * @email       : kpozos@ibl.mx
 * @author      : Karen Yunuen Pozos Arias
 * @title       : Full Stack Developer

 */

import React from 'react';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import {EditIcon} from '../../../../../components/buttons/IconButtons';
import DivContainerBody from '../../../../../components/DivContainerBody';
import HeadTittle from '../../../../../components/HeadTittle';
import { permissionObj } from '../../../../../Helpers/permission';
import UpdateVisitorTypeApp from "../Functionality/UpdateVisitorTypeApp";
import CommonCreateUpdateVisitorTypeApp from "../Functionality/CommonCreateUpdateVisitorTypeApp";
import VisitorTypeForm from "./VisitorTypeForm";

const UpdateVisitorType = () => {
    const props = CommonCreateUpdateVisitorTypeApp();
    const {
        t,
        id,
        location,
        state,
        navigate,
        dispatch,
        permission,
        DEV,
        emptyFields,
        setEmptyFields,
        item,
        setItem,
        fields, setFields,
        fieldData, setFieldData,
        handleChange,
        handleOnBack
    } = props;
    const {handleUpdate} = UpdateVisitorTypeApp({
        t,
        id,
        location,
        state,
        navigate,
        dispatch,
        item,
        setItem,
        fields,
        setFields,
        setEmptyFields,
        setFieldData
    });

    return (
        <>
            <HeadTittle name={'update'} onBack={handleOnBack}>
                {(DEV || permission?.includes( permissionObj?.WEB_VISITOR_TYPE_UPDATE)) && (
                    <ButtonAction
                        id='btn_uvt_update_visitor_type'
                        name={'update'}
                        Icon={EditIcon}
                        className='btn-icon-edit'
                        onClick={handleUpdate}
                    />
                )}
            </HeadTittle>

            <DivContainerBody>
                <VisitorTypeForm
                    item={item}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    fields={fields}
                    setFields={setFields}
                    fieldData={fieldData}
                    setFieldData={setFieldData}
                />
            </DivContainerBody>
        </>
    );
};
export default UpdateVisitorType;
